var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ew-checkbox",class:{
    'ew-checkbox-disabled': _vm.disabled,
    'ew-checkbox-checked': _vm.isChecked,
  },on:{"click":_vm.onClick}},[_c('div',{staticClass:"ew-checkbox-cb",class:{
      'ew-checkbox-cb-disabled': _vm.disabled,
      'ew-checkbox-cb-checked': _vm.isChecked,
    }}),(_vm.labelText)?_c('label',{staticClass:"ew-checkbox-label"},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }